import React from 'react';
import cn from 'classnames';

import Pagination from './Pagination/Pagination';
import SliderDots from '../SliderDots/SliderDots';
import useDeviceTypeDetector from '../../hooks/useDeviceTypeDetector';

import { carouselData } from '../../sections/About/Carousel/Carousel';

import Logo from '../../assets/svg/logo.svg';

import './Header.scss';
import './Pagination/Pagination.scss'

const Header = ({ activeSection, showPagination }) => {
  const { isMobile, isTablet } = useDeviceTypeDetector();

  const className = cn('container', {
    'show-dots': activeSection !== 0 && activeSection <= carouselData.length,
  });

  return (
    <header className={className}>
      <a href="/" className="logo">
        <img src={Logo} alt="Logo" />
      </a>
      {!(isMobile || isTablet) && showPagination &&  (
        <SliderDots
          activeIndex={activeSection - 1}
          count={carouselData.length}
        />
      )}

        {showPagination && (
          <Pagination activeSection={activeSection} />
        )}


    </header>
  );
};

export default Header;
